import React from 'react';
import cx from 'classnames';
import style from './LeftColor.module.css';

/**
 * ## Display a color in the left side of the screen
 * This gives the page a little touch of classy
 */
function LeftColor() {
  return (
    <div
      data-testid="leftColor"
      className={cx(style.colorBlock, 'd-none d-lg-block')}
    />
  );
}

export default LeftColor;
